import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../../services/api';
import { FiMail, FiArrowLeft } from 'react-icons/fi';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setError('Please enter your email address.');
      return;
    }

    try {
      setLoading(true);
      setError('');
      const response = await authService.forgotPassword(email);
      if (response.success) {
        setSent(true);
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
      console.error('Forgot password error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <div className="auth-logo">
            <Logo className="auth-logo-svg" />
          </div>
          <h1>Reset Password</h1>
          <p>Enter your email and we'll send you a reset link</p>
        </div>

        {sent ? (
          <div className="auth-success-message">
            <div className="success-icon">✉️</div>
            <h3>Check Your Email</h3>
            <p>If an account exists for <strong>{email}</strong>, we've sent a password reset link. Check your inbox and spam folder.</p>
            <p className="auth-success-note">The link expires in 24 hours.</p>
            <Link to="/login" className="btn btn-primary btn-block">
              Back to Sign In
            </Link>
          </div>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit}>
            {error && <div className="auth-error">{error}</div>}

            <div className="form-group">
              <label htmlFor="email" className="form-label">Email Address</label>
              <div className="input-with-icon">
                <FiMail className="input-icon" />
                <input
                  type="email"
                  id="email"
                  className="form-input"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setError(''); }}
                  autoFocus
                />
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-block btn-lg"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner spinner-sm"></span>
                  Sending...
                </>
              ) : (
                'Send Reset Link'
              )}
            </button>
          </form>
        )}

        <div className="auth-switch">
          <Link to="/login" className="auth-link">
            <FiArrowLeft /> Back to Sign In
          </Link>
        </div>
      </div>

      <div className="auth-footer">
        <p>The Pearson Clan &bull; Family Network</p>
      </div>
    </div>
  );
};

export default ForgotPassword;